// Micro-haptics for tap feedback.
// navigator.vibrate exists on Android (Chrome/WebView); iOS Safari has no
// vibration API, so calls are silently skipped there.
const canVibrate =
  typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';

export const haptics = {
  /** Light tick for ordinary taps (nav items, list rows). */
  tap() {
    if (canVibrate) navigator.vibrate(10);
  },
  /** Slightly stronger pulse for meaningful selections (cards, confirm). */
  select() {
    if (canVibrate) navigator.vibrate(18);
  },
};
